import React, { FC } from "react";
import Badge from "shared/Badge/Badge";
import { BlogCategory } from "types/blog";

export interface CategoryBadgeListProps {
  className?: string;
  itemClass?: string;
  category: BlogCategory;
}

const CategoryBadgeList: FC<CategoryBadgeListProps> = ({
  className = "flex flex-wrap space-x-2",
  itemClass,
  category,
}) => {
  return (
    <div
      className={`nc-CategoryBadgeList ${className}`}
      data-nc-id="CategoryBadgeList"
    >
      <Badge className={itemClass} name={category} />
    </div>
  );
};

export default CategoryBadgeList;
